import sample_01 from './hiVis.jpg';
import sample_02 from './hiVis2.jpg';

export const hivisImpressions = {
    sample_01,
    sample_02,
};
